import type { Batch, BatchItem } from '@rpldy/uploady'
import { FILE_STATES } from '@rpldy/uploady'
import { useEffect, useRef } from 'react'

import { useListenersContext } from '../UploadManage.context'

export const useUploadBatchProgress = (id: string, func: (data: BatchItem[]) => void) => {
    const { batchListener } = useListenersContext()

    const latestFunc = useRef<(data: BatchItem[]) => void>(func)
    latestFunc.current = func

    useEffect(() => {
        batchListener.add(latestFunc.current, id, FILE_STATES.PENDING)

        // return () => {
        //     batchListener.remove(id)
        // }
    }, [id, batchListener])
}
